<script lang="ts">
    import EarlyReviewerBadge from "$components/badges/EarlyReviewerBadge.svelte";
    import AddReviewCTA from "$components/AddReviewCTA.svelte";

    export let buildingName = '';
    export let buildingId = '';
</script>

<section class="bg-primary-500 text-white p-5 rounded-xl">
    <p>
        This building needs more reviews!
    </p>

    <p class="mt-5">
        <strong>The first 5 reviews</strong> automatically receive an <EarlyReviewerBadge inverted={true} />
        designation. <span class="font-bold">Review {buildingName} now to earn your badge.</span>
    </p>

    <AddReviewCTA {buildingId}
                  inverted="{true}"
                  textSize='text-base' buttonSize='btn-base' classes='w-full md:w-fit m-auto mt-5'/>
</section>

<style>
    section {
        background: var(--radial-blue, linear-gradient(180deg, rgba(154, 199, 252, 0.23) 0%, rgba(156, 255, 160, 0.30) 100%), #2768B5);
    }
</style>